// src/auth/RequireTenant.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";

const isIp = (hostname) => /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

function slugFromHost() {
  const hostname = window.location.hostname;
  if (!hostname || hostname === "localhost" || isIp(hostname)) return "";
  const parts = hostname.split(".");
  if (parts.length >= 3) return parts[0];
  return "";
}

export default function RequireTenant({ children }) {
  const isDemoMode = import.meta.env.VITE_DEMO_MODE === "true";
  const slug = useMemo(() => slugFromHost(), []);
  const [state, setState] = useState({ loading: true, ok: true });

  useEffect(() => {
    let cancelled = false;

    async function run() {
      // Static demo should not depend on a real tenant existing in backend.
      if (isDemoMode) {
        setState({ loading: false, ok: true });
        return;
      }

      // On localhost/IP we cannot infer tenant slug, so do not block dev.
      if (!slug) {
        setState({ loading: false, ok: true });
        return;
      }

      try {
        await api.get("/public/tenant", { params: { business_slug: slug } });
        if (!cancelled) setState({ loading: false, ok: true });
      } catch (e) {
        const code = e?.response?.status;
        if (!cancelled) setState({ loading: false, ok: !(code === 404) });
      }
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [isDemoMode, slug]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-sm text-slate-600">Se incarca...</div>
      </div>
    );
  }

  if (!state.ok) {
    return <Navigate to="/business-not-found" replace />;
  }

  return children;
}
